/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unlocked! You can now use ${i?.feature}.`)
};

const es_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Desbloqueado! Ahora puedes usar ${i?.feature}.`)
};

const de_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Freigeschaltet! Du kannst jetzt ${i?.feature} nutzen.`)
};

const nl_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ontgrendeld! Je kunt nu ${i?.feature} gebruiken.`)
};

const fr_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Déverrouillé ! Vous pouvez maintenant utiliser ${i?.feature}.`)
};

const it_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sbloccato! Ora puoi usare ${i?.feature}.`)
};

const pt_br2_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desbloqueado! Agora você pode usar ${i?.feature}.`)
};

const pt_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desbloqueado! Já pode usar ${i?.feature}.`)
};

const ja_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アンロック完了！${i?.feature}を使用できます。`)
};

const zh_f1_ad_unlocked_success = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已解锁！您现在可以使用${i?.feature}。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ feature: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ad_unlocked_success = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ad_unlocked_success(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ad_unlocked_success", locale)
	if (locale === "en") return en_f1_ad_unlocked_success(inputs)
	if (locale === "es") return es_f1_ad_unlocked_success(inputs)
	if (locale === "de") return de_f1_ad_unlocked_success(inputs)
	if (locale === "nl") return nl_f1_ad_unlocked_success(inputs)
	if (locale === "fr") return fr_f1_ad_unlocked_success(inputs)
	if (locale === "it") return it_f1_ad_unlocked_success(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ad_unlocked_success(inputs)
	if (locale === "pt") return pt_f1_ad_unlocked_success(inputs)
	if (locale === "ja") return ja_f1_ad_unlocked_success(inputs)
	return zh_f1_ad_unlocked_success(inputs)
};